
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useContentFreshness = () => {
  return useQuery({
    queryKey: ['content-freshness'],
    queryFn: async () => {
      console.log('Fetching content freshness data...');
      
      try {
        // Get trending games count
        const { count: trendingCount } = await supabase
          .from('games')
          .select('*', { count: 'exact', head: true })
          .eq('trending', true)
          .eq('hidden', false);

        // Get new games count (last 7 days)
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
        
        const { count: newGamesCount } = await supabase
          .from('games')
          .select('*', { count: 'exact', head: true })
          .eq('hidden', false)
          .gte('created_at', sevenDaysAgo.toISOString());

        // Get recently updated games
        const { data: recentlyUpdated } = await supabase
          .from('games')
          .select('id, title, updated_at')
          .eq('hidden', false)
          .order('updated_at', { ascending: false })
          .limit(5);

        // Get total play count for freshness signals
        const { data: playStats } = await supabase
          .from('games')
          .select('play_count, fake_play_count')
          .eq('hidden', false);

        const totalPlays = playStats?.reduce((sum, game) => {
          return sum + (game.fake_play_count || game.play_count || 0);
        }, 0) || 0;

        console.log('Content freshness fetched successfully');

        return {
          trendingCount: trendingCount || 0,
          newGamesCount: newGamesCount || 0,
          recentlyUpdated: recentlyUpdated || [],
          totalPlays,
          lastUpdated: new Date().toISOString()
        };
      } catch (err) {
        console.error('Error in content freshness query:', err);
        // Return default data on error
        return {
          trendingCount: 0,
          newGamesCount: 0,
          recentlyUpdated: [],
          totalPlays: 0,
          lastUpdated: new Date().toISOString()
        };
      }
    },
    staleTime: 2 * 60 * 1000, // 2 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchInterval: false, // Remove auto-refetch
  });
};
